import { render } from "./Admin.Tests.VideoViewer.vue?vue&type=template&id=7ee702d0"
import script from "./Admin.Tests.VideoViewer.vue?vue&type=script&lang=js"
export * from "./Admin.Tests.VideoViewer.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__